<template>
  <div>
    <header-unauthenticated></header-unauthenticated>
    <div class="container">
      <div class="login login--header-padding">
        <img src="@/assets/superliga/logo-3x.png" alt="" class="login__logo" v-if="$config.MODE == 'SUPERLIGA'">
        <img src="@/assets/logo.svg" alt="" class="login__logo" v-else>
        <h4>{{$t('recoveryPassword.legend')}}</h4>

        <div class="form-group">
          <input 
          type="number"
          v-model.trim="$v.recoveryModel.activationCode.$model"
          :class="{'has-error': $v.recoveryModel.activationCode.$error && $v.recoveryModel.activationCode.$invalid, 'with-value': $v.recoveryModel.activationCode.$model != ''}"
          :id="$t('recoveryPassword.form.verifyCode')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('recoveryPassword.form.verifyCode')">{{$t('recoveryPassword.form.verifyCode')}}</label>
        </div>
        <div class="form-group">
          <input 
          type="password"
          v-model.trim="$v.recoveryModel.password.$model"
          :class="{'has-error': $v.recoveryModel.password.$error && $v.recoveryModel.password.$invalid, 'with-value': $v.recoveryModel.password.$model != ''}"
          :id="$t('recoveryPassword.form.newPassword')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('recoveryPassword.form.newPassword')">{{$t('recoveryPassword.form.newPassword')}}</label>
        </div>
        <div class="form-group">
          <input 
          type="password"
          v-model.trim="$v.recoveryModel.passwordConfirm.$model"
          :class="{'has-error': $v.recoveryModel.passwordConfirm.$error && $v.recoveryModel.passwordConfirm.$invalid, 'with-value': $v.recoveryModel.passwordConfirm.$model != ''}"
          :id="$t('recoveryPassword.form.repeatNewPassword')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('recoveryPassword.form.repeatNewPassword')">{{$t('recoveryPassword.form.repeatNewPassword')}}</label>
        </div>
          
        <button class="button button--white" @click.prevent="recoveryCode()" :disabled="$v.recoveryModel.$invalid || submitted">
          <template v-if="!submitted">
            {{$t('recoveryPassword.changePassword')}}
          </template>
          <template v-else>
            {{$t('recoveryPassword.loadingChangePassword')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
          </template>
        </button>
        <button class="button button--clean" @click.prevent="sendCode()">{{$t('recoveryPassword.sendCode')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import HeaderUnauthenticated from '@/components/Header/Unauthenticated.vue'

export default {
  components: {
    HeaderUnauthenticated
  },
  data() {
    return {
      recoveryModel: {
        activationCode: "",
        password: "",
        passwordConfirm: ""
      },
      submitted: false
    }
  },
  methods: {
    async recoveryCode() {
      const self = this
      self.$v.$touch()
      if (!self.$v.$invalid) {
        this.submitted = true
        const request = await this.$store.dispatch('endPasswordRecovery', {
          ...self.recoveryModel,
          email: this.$route.params.email
        })
        if (request == undefined) this.submitted = false
        if (request.status == 200) this.$router.push('/recoverPassword/successful')
      }
    },
    async sendCode() {
      const request = await this.$store.dispatch("resendActivationMail", {
        email: this.$route.params.email
      })
      if (request.status == 200) console.log("Mostrar notificación de activación mail")
    }
  },
  validations: {
    recoveryModel: {
      activationCode: {
        required
      },
      password: {
        required
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs("password")
      },
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';
</style>